import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../layout/MainLayout';
import { useLocation } from 'react-router-dom';
import { API_BASE } from "../config/orbisConfig";




const TEMPLATE_CATEGORIES = [
    "General",
    "PMO Base",
    "Estratégico",
    "Comercial",
    "Institucional",
    "Afiliación",
    "Evento",
    "Tecnología",
    "Implementación",
    "Seguimiento",
    "Cierre",
];



const orbis = {
    navy: "#041c2c",
    navy2: "#06263a",
    cyan: "#38d5ff",
    cyanSoft: "#b9e8ff",
    yellow: "#f4b91b",
    purple: "#8b5cf6",
    border: "rgba(56,213,255,.28)",
};

function Card({ title, children, right, subtitle, dark = false }) {
    return (
        <section
            style={{
                background: dark
                    ? "linear-gradient(180deg, rgba(8,47,73,.96), rgba(2,25,48,.98))"
                    : "#ffffff",
                border: dark ? `1px solid ${orbis.border}` : "1px solid #dbe4ee",
                borderRadius: 18,
                padding: 22,
                marginBottom: 18,
                boxShadow: dark ? "0 18px 34px rgba(0,0,0,.20)" : "0 10px 28px rgba(15,23,42,.08)",
            }}
        >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 14, marginBottom: 16, flexWrap: "wrap" }}>
                <div>
                    <h3 style={{ margin: 0, fontSize: 18, color: dark ? "#ffffff" : "#0f172a", fontWeight: 900 }}>{title}</h3>
                    {subtitle ? <div style={{ color: dark ? orbis.cyanSoft : "#64748b", marginTop: 6, fontSize: 13, lineHeight: 1.45 }}>{subtitle}</div> : null}
                </div>
                <div>{right}</div>
            </div>
            {children}
        </section>
    );
}

function Button({ children, ...props }) {
    return (
        <button
            {...props}
            style={{
                padding: props.size === "sm" ? "8px 12px" : "11px 15px",
                borderRadius: 999,
                border: props.border || "1px solid rgba(15,23,42,.12)",
                background: props.disabled ? "#94a3b8" : (props.bg || "#06111f"),
                color: props.color || "#fff",
                fontWeight: 900,
                cursor: props.disabled ? "not-allowed" : "pointer",
                marginRight: 8,
                marginBottom: 8,
                boxShadow: props.shadow || "0 8px 18px rgba(15,23,42,.10)",
                letterSpacing: ".01em",
                ...props.style,
            }}
        >
            {children}
        </button>
    );
}

function Input({ label, value, onChange, hint, ...props }) {
    return (
        <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, color: "#2563eb", marginBottom: 6, fontWeight: 900, letterSpacing: ".04em", textTransform: "uppercase" }}>{label}</div>
            <input
                value={value ?? ""}
                onChange={onChange}
                {...props}
                style={{
                    width: "100%",
                    padding: "11px 12px",
                    borderRadius: 12,
                    border: "1px solid #cbd5e1",
                    fontSize: 14,
                    boxSizing: "border-box",
                    background: "#fff",
                    color: "#0f172a",
                    outline: "none",
                }}
            />
            {hint ? <div style={{ fontSize: 11, color: "#64748b", marginTop: 5 }}>{hint}</div> : null}
        </div>
    );
}

function Select({ label, value, onChange, children, hint }) {
    return (
        <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, color: "#2563eb", marginBottom: 6, fontWeight: 900, letterSpacing: ".04em", textTransform: "uppercase" }}>{label}</div>
            <select
                value={value ?? ""}
                onChange={onChange}
                style={{
                    width: "100%",
                    padding: "11px 12px",
                    borderRadius: 12,
                    border: "1px solid #cbd5e1",
                    fontSize: 14,
                    boxSizing: "border-box",
                    background: "#fff",
                    color: "#0f172a",
                    outline: "none",
                }}
            >
                {children}
            </select>
            {hint ? <div style={{ fontSize: 11, color: "#64748b", marginTop: 5 }}>{hint}</div> : null}
        </div>
    );
}

function Textarea({ label, value, onChange, rows = 4, hint }) {
    return (
        <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, color: "#2563eb", marginBottom: 6, fontWeight: 900, letterSpacing: ".04em", textTransform: "uppercase" }}>{label}</div>
            <textarea
                rows={rows}
                value={value ?? ""}
                onChange={onChange}
                style={{
                    width: "100%",
                    padding: "11px 12px",
                    borderRadius: 12,
                    border: "1px solid #cbd5e1",
                    fontSize: 14,
                    boxSizing: "border-box",
                    resize: "vertical",
                    background: "#fff",
                    color: "#0f172a",
                    outline: "none",
                }}
            />
            {hint ? <div style={{ fontSize: 11, color: "#64748b", marginTop: 5 }}>{hint}</div> : null}
        </div>
    );
}

function Pill({ children, tone = "blue" }) {
    const tones = {
        blue: { bg: "rgba(14,165,233,.14)", color: "#075985", border: "rgba(14,165,233,.28)" },
        green: { bg: "rgba(16,185,129,.14)", color: "#047857", border: "rgba(16,185,129,.28)" },
        yellow: { bg: "rgba(244,185,27,.18)", color: "#92400e", border: "rgba(244,185,27,.38)" },
        purple: { bg: "rgba(139,92,246,.14)", color: "#6d28d9", border: "rgba(139,92,246,.30)" },
        slate: { bg: "rgba(100,116,139,.12)", color: "#334155", border: "rgba(100,116,139,.22)" },
    };
    const cfg = tones[tone] || tones.blue;
    return (
        <span style={{ display: "inline-flex", alignItems: "center", padding: "6px 10px", borderRadius: 999, fontSize: 12, fontWeight: 900, background: cfg.bg, color: cfg.color, border: `1px solid ${cfg.border}`, whiteSpace: "nowrap" }}>
            {children}
        </span>
    );
}

function CopyChip({ active, label }) {
    return (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "6px 9px",
                borderRadius: 999,
                fontSize: 11,
                fontWeight: 900,
                border: active ? "1px solid rgba(56,213,255,.32)" : "1px solid rgba(148,163,184,.25)",
                background: active ? "rgba(14,165,233,.13)" : "rgba(148,163,184,.08)",
                color: active ? "#d7f5ff" : "#cbd5e1",
            }}
        >
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: active ? "#38d5ff" : "#94a3b8" }} />
            {label}
        </span>
    );
}

function countValue(tpl, keys) {
    for (const k of keys) {
        if (tpl[k] !== undefined && tpl[k] !== null && tpl[k] !== "") return Number(tpl[k]) || 0;
    }
    return null;
}

function templateCountRows(tpl) {
    return [
        ["Áreas", countValue(tpl, ["areas_count", "project_areas_count", "total_areas"])],
        ["WBS", countValue(tpl, ["tasks_count", "project_tasks_count", "total_tasks"])],
        ["Riesgos", countValue(tpl, ["risks_count", "project_risks_count", "total_risks"])],
        ["Entregables", countValue(tpl, ["deliverables_count", "project_deliverables_count", "total_deliverables"])],
        ["Hitos", countValue(tpl, ["milestones_count", "project_milestones_count", "total_milestones"])],
        ["Stakeholders", countValue(tpl, ["stakeholders_count", "project_stakeholders_count", "total_stakeholders"])],
    ];
}

function TemplateCard({ tpl, selected, onUse, onSelect }) {
    const countRows = templateCountRows(tpl);
    const copyAreas = tpl.copy_areas === undefined ? true : !!Number(tpl.copy_areas);
    const copyMilestones = tpl.copy_milestones === undefined ? true : !!Number(tpl.copy_milestones);
    const copyStakeholders = tpl.copy_stakeholders === undefined ? true : !!Number(tpl.copy_stakeholders);

    return (
        <article
            onClick={onSelect}
            style={{
                borderRadius: 18,
                padding: 18,
                background: "linear-gradient(180deg, rgba(8,47,73,.96), rgba(2,25,48,.98))",
                border: selected ? "2px solid #f4b91b" : "1px solid rgba(56,213,255,.28)",
                boxShadow: selected ? "0 18px 34px rgba(244,185,27,.16)" : "0 14px 30px rgba(0,0,0,.18)",
                cursor: "pointer",
            }}
        >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 16, alignItems: "flex-start", flexWrap: "wrap" }}>
                <div style={{ minWidth: 280, flex: "1 1 420px" }}>
                    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 8 }}>
                        <Pill tone="yellow">{tpl.category || "General"}</Pill>
                        {selected ? <Pill tone="purple">Seleccionada</Pill> : null}
                    </div>
                    <h3 style={{ margin: "0 0 8px", color: "#ffffff", fontSize: 20, fontWeight: 950 }}>{tpl.name}</h3>
                    <p style={{ margin: 0, color: "#d7efff", fontSize: 13, lineHeight: 1.55 }}>{tpl.description || "Sin descripción ejecutiva capturada."}</p>
                    <div style={{ marginTop: 10, color: "#8edcff", fontSize: 12 }}>
                        Origen: <strong style={{ color: "#ffffff" }}>{tpl.source_project_name || `Proyecto ${tpl.source_project_id || "—"}`}</strong>
                    </div>
                </div>

                <div style={{ flex: "0 1 360px", width: 360, maxWidth: "100%" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(70px, 1fr))", gap: 8, marginBottom: 12 }}>
                        {countRows.map(([label, value]) => (
                            <div key={label} style={{ border: "1px solid rgba(125,211,252,.18)", borderRadius: 12, padding: "8px 9px", background: "rgba(255,255,255,.04)" }}>
                                <div style={{ fontSize: 10, color: "#7dd3fc", fontWeight: 900, letterSpacing: ".04em", textTransform: "uppercase" }}>{label}</div>
                                <div style={{ color: "#ffffff", fontWeight: 950, fontSize: 18 }}>{value === null ? "—" : value}</div>
                            </div>
                        ))}
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 7, marginBottom: 12 }}>
                        <CopyChip active={!!Number(tpl.copy_scope)} label="Alcance" />
                        <CopyChip active={copyAreas} label="Áreas" />
                        <CopyChip active={!!Number(tpl.copy_tasks)} label="WBS" />
                        <CopyChip active={!!Number(tpl.copy_risks)} label="Riesgos" />
                        <CopyChip active={!!Number(tpl.copy_deliverables)} label="Entregables" />
                        <CopyChip active={copyMilestones} label="Hitos" />
                        <CopyChip active={copyStakeholders} label="Stakeholders" />
                        <CopyChip active={!!Number(tpl.copy_documents)} label="Documentos base" />
                    </div>
                    <Button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            onUse();
                        }}
                        bg="#f4b91b"
                        color="#06111f"
                        border="1px solid rgba(244,185,27,.75)"
                        shadow="0 12px 24px rgba(244,185,27,.18)"
                    >
                        Usar plantilla
                    </Button>
                </div>
            </div>
        </article>
    );
}

function safeFetchJson(url, options = {}) {
    return fetch(url, options).then(async (res) => {
        const raw = await res.text();
        let data = null;
        try { data = raw ? JSON.parse(raw) : null; } catch {
            throw new Error(`Respuesta inválida en ${url}: ${raw || '[vacío]'}`);
        }
        if (!res.ok || data?.success === false) {
            throw new Error(data?.message || `Error en ${url}`);
        }
        return data;
    });
}


const toNullableId = (value) => {
    if (value === undefined || value === null || value === "" || value === "0" || value === 0) return null;
    return Number(value);
};

const emptyCreate = {
    source_project_id: '',
    name: '',
    description: '',
    category: 'General',
    copy_scope: true,
    copy_tasks: true,
    copy_risks: true,
    copy_deliverables: true,
    copy_documents: false,
};

const emptyApply = {
    template_id: '',
    account_id: '',
    opportunity_id: '',
    project_name: '',
    project_code: '',
    project_manager_user_id: '',
    sponsor_user_id: '',
    created_by_user_id: '',
    planned_start_date: '',
    planned_end_date: '',
};

export default function ProjectTemplateLibraryPage() {
    const location = useLocation();

    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);
    const [projects, setProjects] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [opportunities, setOpportunities] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [savingCreate, setSavingCreate] = useState(false);
    const [savingApply, setSavingApply] = useState(false);
    const [error, setError] = useState('');
    const [toast, setToast] = useState('');
    const [createForm, setCreateForm] = useState(emptyCreate);
    const [applyForm, setApplyForm] = useState(emptyApply);

    const selectedTemplate = useMemo(
        () => templates.find((t) => String(t.id) === String(applyForm.template_id)) || null,
        [templates, applyForm.template_id]
    );

    const loadAll = async () => {
        setLoading(true);
        setError('');
        try {
            const [templatesPayload, projectsPayload, accountsPayload, opportunitiesPayload, usersPayload] = await Promise.all([
                safeFetchJson(`${API_BASE}/project_templates_list.php`),
                safeFetchJson(`${API_BASE}/projects_list.php`),
                safeFetchJson(`${API_BASE}/accounts_list.php`),
                safeFetchJson(`${API_BASE}/opportunities_list.php`),
                safeFetchJson(`${API_BASE}/catalog_users_list.php`),
            ]);

            setTemplates(Array.isArray(templatesPayload.data) ? templatesPayload.data : []);
            setProjects(Array.isArray(projectsPayload) ? projectsPayload : (projectsPayload.projects || projectsPayload.data || []));
            setAccounts(Array.isArray(accountsPayload) ? accountsPayload : (accountsPayload.accounts || accountsPayload.data || []));
            setOpportunities(Array.isArray(opportunitiesPayload) ? opportunitiesPayload : (opportunitiesPayload.opportunities || opportunitiesPayload.data || []));
            setUsers(Array.isArray(usersPayload.data) ? usersPayload.data : []);
        } catch (err) {
            setError(err.message || 'No se pudo cargar la librería de plantillas');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadAll(); }, []);
    useEffect(() => {
        if (!toast) return;
        const t = setTimeout(() => setToast(''), 3200);
        return () => clearTimeout(t);
    }, [toast]);

    useEffect(() => {
        if (!location.state?.fromProject) return;

        const data = location.state.templateData;

        if (!data) return;

        setCreateForm((prev) => ({
            ...prev,
            source_project_id: data.source_project_id || '',
            name: data.name || '',
            description: data.description || '',
        }));
    }, [location.state]);

    const handleCreateChange = (key, value) => setCreateForm((prev) => ({ ...prev, [key]: value }));
    const handleApplyChange = (key, value) => setApplyForm((prev) => ({ ...prev, [key]: value }));

    const useTemplate = (tpl) => {
        setApplyForm((prev) => ({
            ...prev,
            template_id: String(tpl.id || ''),
            project_name: prev.project_name || '',
            project_code: prev.project_code || '',
        }));
        setToast('');
        setError('');
    };

    const submitCreate = async (e) => {
        e.preventDefault();
        try {
            setSavingCreate(true);
            if (!createForm.source_project_id) throw new Error('Selecciona un proyecto origen');
            if (!String(createForm.name || '').trim()) throw new Error('El nombre de la plantilla es obligatorio');

            await safeFetchJson(`${API_BASE}/project_template_create.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    source_project_id: Number(createForm.source_project_id),
                    name: String(createForm.name || '').trim(),
                    description: String(createForm.description || '').trim() || null,
                    category: String(createForm.category || '').trim() || 'General',
                    copy_scope: !!createForm.copy_scope,
                    copy_tasks: !!createForm.copy_tasks,
                    copy_risks: !!createForm.copy_risks,
                    copy_deliverables: !!createForm.copy_deliverables,
                    copy_documents: !!createForm.copy_documents,
                })
            });

            setToast('Plantilla creada correctamente');
            setCreateForm(emptyCreate);
            await loadAll();
        } catch (err) {
            setError(err.message || 'No se pudo crear la plantilla');
        } finally {
            setSavingCreate(false);
        }
    };

    const submitApply = async (e) => {
        e.preventDefault();
        try {
            setSavingApply(true);
            if (!applyForm.template_id) throw new Error('Selecciona una plantilla');
            if (!String(applyForm.project_name || '').trim()) throw new Error('El nombre del proyecto es obligatorio');

            const payload = await safeFetchJson(`${API_BASE}/project_template_apply.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    template_id: Number(applyForm.template_id),
                    account_id: toNullableId(applyForm.account_id),
                    opportunity_id: toNullableId(applyForm.opportunity_id),
                    project_name: String(applyForm.project_name || '').trim(),
                    project_code: String(applyForm.project_code || '').trim() || null,
                    project_manager_user_id: String(applyForm.project_manager_user_id || '').trim() ? Number(applyForm.project_manager_user_id) : null,
                    sponsor_user_id: String(applyForm.sponsor_user_id || '').trim() ? Number(applyForm.sponsor_user_id) : null,
                    created_by_user_id: String(applyForm.created_by_user_id || '').trim() ? Number(applyForm.created_by_user_id) : null,
                    planned_start_date: String(applyForm.planned_start_date || '').trim() || null,
                    planned_end_date: String(applyForm.planned_end_date || '').trim() || null,
                })
            });

            const newId = payload.project_id || payload.id;
            if (newId) {
                navigate(`/projects/${newId}`);
                return;
            }
            setToast('Proyecto creado desde plantilla');
            setApplyForm(emptyApply);
        } catch (err) {
            setError(err.message || 'No se pudo aplicar la plantilla');
        } finally {
            setSavingApply(false);
        }
    };

    if (loading) {
        return (
            <MainLayout>
                <div style={{ padding: 24, background: "#eef4f8", minHeight: "100vh" }}>
                    <Card dark title="Cargando biblioteca ORBIS" subtitle="Preparando plantillas reutilizables y estructura PMO." />
                </div>
            </MainLayout>
        );
    }

    const totalTemplates = templates.length;
    const selectedTemplateCounts = selectedTemplate ? templateCountRows(selectedTemplate) : [];

    return (
        <MainLayout>
            <div style={{ padding: 24, background: "#eef4f8", minHeight: "100vh" }}>
                <section
                    style={{
                        background: "linear-gradient(135deg, #052b40 0%, #06384f 48%, #041c2c 100%)",
                        border: "1px solid rgba(56,213,255,.28)",
                        borderRadius: 22,
                        padding: 28,
                        marginBottom: 20,
                        boxShadow: "0 18px 34px rgba(15,23,42,.18)",
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16, flexWrap: "wrap" }}>
                        <div>
                            <div style={{ color: "#f4b91b", fontSize: 12, fontWeight: 950, letterSpacing: ".12em", textTransform: "uppercase", marginBottom: 10 }}>
                                Biblioteca ORBIS PRO
                            </div>
                            <h1 style={{ margin: 0, fontSize: 34, color: "#ffffff", fontWeight: 950 }}>PMO · Plantillas reutilizables</h1>
                            <p style={{ color: "#d7efff", marginTop: 10, fontSize: 15, lineHeight: 1.55, maxWidth: 850 }}>
                                Convierte proyectos modelo en nuevos proyectos operables con alcance, áreas, WBS, riesgos, entregables, hitos y stakeholders. El CRM es opcional: ORBIS puede crear proyectos independientes.
                            </p>
                            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 16 }}>
                                <Pill tone="yellow">{totalTemplates} plantilla(s)</Pill>
                                <Pill tone="blue">CRM opcional</Pill>
                                <Pill tone="purple">Proyecto modelo → Proyecto operable</Pill>
                            </div>
                        </div>
                        <Button onClick={() => navigate('/projects')} bg="#ffffff" color="#06111f" border="1px solid rgba(255,255,255,.75)">
                            ← Volver a proyectos
                        </Button>
                    </div>
                </section>

                {error ? <div style={{ background: "#fee2e2", color: "#991b1b", padding: 14, borderRadius: 14, marginBottom: 16, fontWeight: 800 }}>{error}</div> : null}
                {toast ? <div style={{ background: "#ecfdf5", color: "#166534", padding: 14, borderRadius: 14, marginBottom: 16, fontWeight: 800 }}>{toast}</div> : null}

                <Card
                    title="Plantillas disponibles"
                    subtitle="Selecciona una plantilla para crear un proyecto nuevo con estructura PMO lista."
                    right={<Pill tone="yellow">{templates.length} registrada(s)</Pill>}
                >
                    {templates.length === 0 ? (
                        <div style={{ color: "#64748b" }}>No hay plantillas todavía.</div>
                    ) : (
                        <div style={{ display: "grid", gap: 14 }}>
                            {templates.map((tpl) => (
                                <TemplateCard
                                    key={tpl.id}
                                    tpl={tpl}
                                    selected={String(applyForm.template_id) === String(tpl.id)}
                                    onSelect={() => useTemplate(tpl)}
                                    onUse={() => useTemplate(tpl)}
                                />
                            ))}
                        </div>
                    )}
                </Card>

                <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1.15fr) minmax(360px, .85fr)", gap: 18, alignItems: "start" }}>
                    <Card
                        title="Usar plantilla para nuevo proyecto"
                        subtitle="Crea un proyecto nuevo independiente o vinculado al CRM. ORBIS copiará la estructura definida por la plantilla."
                    >
                        <form onSubmit={submitApply}>
                            <Select label="Plantilla" value={applyForm.template_id} onChange={(e) => handleApplyChange('template_id', e.target.value)}>
                                <option value="">Selecciona plantilla</option>
                                {templates.map((tpl) => <option key={tpl.id} value={tpl.id}>{tpl.name}</option>)}
                            </Select>

                            {selectedTemplate ? (
                                <div
                                    style={{
                                        background: "linear-gradient(180deg, rgba(8,47,73,.96), rgba(2,25,48,.98))",
                                        border: "1px solid rgba(56,213,255,.28)",
                                        borderRadius: 16,
                                        padding: 15,
                                        marginBottom: 16,
                                    }}
                                >
                                    <div style={{ color: "#f4b91b", fontSize: 11, fontWeight: 950, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>
                                        Plantilla seleccionada
                                    </div>
                                    <div style={{ color: "#ffffff", fontWeight: 950, fontSize: 17 }}>{selectedTemplate.name}</div>
                                    <div style={{ color: "#d7efff", fontSize: 13, lineHeight: 1.5, marginTop: 6 }}>{selectedTemplate.description || 'Sin descripción'}</div>
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginTop: 12 }}>
                                        {selectedTemplateCounts.map(([label, value]) => (
                                            <div key={label} style={{ background: "rgba(255,255,255,.04)", border: "1px solid rgba(125,211,252,.18)", borderRadius: 12, padding: 9 }}>
                                                <div style={{ color: "#7dd3fc", fontSize: 10, fontWeight: 900, textTransform: "uppercase" }}>{label}</div>
                                                <div style={{ color: "#fff", fontWeight: 950, fontSize: 17 }}>{value === null ? "—" : value}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : null}

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                                <Input label="Nombre del proyecto nuevo" value={applyForm.project_name} onChange={(e) => handleApplyChange('project_name', e.target.value)} />
                                <Input label="Código" value={applyForm.project_code} onChange={(e) => handleApplyChange('project_code', e.target.value)} />
                            </div>

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                                <Select label="Cuenta" hint="Opcional. Deja vacío para proyecto independiente." value={applyForm.account_id} onChange={(e) => handleApplyChange('account_id', e.target.value)}>
                                    <option value="">Sin cuenta / proyecto independiente</option>
                                    {accounts.map((a) => <option key={a.id} value={a.id}>{a.name || a.account_name || `Cuenta ${a.id}`}</option>)}
                                </Select>
                                <Select label="Oportunidad" hint="Opcional. Solo aplica si se vincula a CRM." value={applyForm.opportunity_id} onChange={(e) => handleApplyChange('opportunity_id', e.target.value)}>
                                    <option value="">Sin oportunidad</option>
                                    {opportunities.map((o) => <option key={o.id} value={o.id}>{o.name || o.opportunity_name || `Oportunidad ${o.id}`}</option>)}
                                </Select>
                            </div>

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                                <Select label="Project Manager" value={applyForm.project_manager_user_id} onChange={(e) => handleApplyChange('project_manager_user_id', e.target.value)}>
                                    <option value="">Sin asignar</option>
                                    {users.map((u) => <option key={u.id} value={u.id}>{u.display_name || u.label || `Usuario ${u.id}`}</option>)}
                                </Select>
                                <Select label="Sponsor" value={applyForm.sponsor_user_id} onChange={(e) => handleApplyChange('sponsor_user_id', e.target.value)}>
                                    <option value="">Sin asignar</option>
                                    {users.map((u) => <option key={u.id} value={u.id}>{u.display_name || u.label || `Usuario ${u.id}`}</option>)}
                                </Select>
                            </div>

                            <Select label="Creado por" value={applyForm.created_by_user_id} onChange={(e) => handleApplyChange('created_by_user_id', e.target.value)}>
                                <option value="">Sin asignar</option>
                                {users.map((u) => <option key={u.id} value={u.id}>{u.display_name || u.label || `Usuario ${u.id}`}</option>)}
                            </Select>

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                                <Input type="date" label="Inicio planeado" value={applyForm.planned_start_date} onChange={(e) => handleApplyChange('planned_start_date', e.target.value)} />
                                <Input type="date" label="Fin planeado" value={applyForm.planned_end_date} onChange={(e) => handleApplyChange('planned_end_date', e.target.value)} />
                            </div>

                            <div style={{ marginTop: 6, display: "flex", gap: 8, flexWrap: "wrap" }}>
                                <Button type="submit" disabled={savingApply} bg="#06111f" color="#fff">
                                    {savingApply ? 'Creando...' : 'Crear proyecto desde plantilla'}
                                </Button>
                                <Button type="button" bg="#fff" color="#06111f" border="1px solid #cbd5e1" onClick={() => setApplyForm(emptyApply)}>
                                    Limpiar
                                </Button>
                            </div>
                        </form>
                    </Card>

                    <Card
                        title="Crear plantilla desde proyecto"
                        subtitle="Convierte un proyecto ya estructurado en modelo reutilizable. Esta acción es administrativa."
                    >
                        <form onSubmit={submitCreate}>
                            <Select label="Proyecto origen" value={createForm.source_project_id} onChange={(e) => handleCreateChange('source_project_id', e.target.value)}>
                                <option value="">Selecciona proyecto</option>
                                {projects.map((p) => <option key={p.id} value={p.id}>{p.name || `Proyecto ${p.id}`}</option>)}
                            </Select>
                            <Input label="Nombre de la plantilla" value={createForm.name} onChange={(e) => handleCreateChange('name', e.target.value)} />
                            <Select label="Categoría de plantilla" value={createForm.category} onChange={(e) => handleCreateChange('category', e.target.value)}>
                                {TEMPLATE_CATEGORIES.map((cat) => (
                                    <option key={cat} value={cat}>{cat}</option>
                                ))}
                            </Select>
                            <Textarea label="Descripción" value={createForm.description} onChange={(e) => handleCreateChange('description', e.target.value)} rows={4} />

                            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 14, padding: 14, marginBottom: 16 }}>
                                <div style={{ color: "#0f172a", fontWeight: 900, marginBottom: 10 }}>Estructura a copiar</div>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                                    {[
                                        ['copy_scope', 'Copiar alcance'],
                                        ['copy_tasks', 'Copiar tareas WBS'],
                                        ['copy_risks', 'Copiar riesgos'],
                                        ['copy_deliverables', 'Copiar entregables'],
                                        ['copy_documents', 'Copiar documentos base'],
                                    ].map(([key, label]) => (
                                        <label key={key} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#0f172a", fontWeight: 800 }}>
                                            <input type="checkbox" checked={!!createForm[key]} onChange={(e) => handleCreateChange(key, e.target.checked)} />
                                            {label}
                                        </label>
                                    ))}
                                </div>
                                <div style={{ color: "#64748b", fontSize: 12, marginTop: 10 }}>
                                    Áreas, hitos y stakeholders se copian desde el endpoint PRO cuando la plantilla los tenga disponibles.
                                </div>
                            </div>

                            <Button type="submit" disabled={savingCreate}>
                                {savingCreate ? 'Guardando...' : 'Crear plantilla'}
                            </Button>
                        </form>
                    </Card>
                </div>
            </div>
        </MainLayout>
    );
}
